import PropTypes from 'prop-types';
import clsx from 'clsx';
import classes from './style.module.css';

const OptionCardGroup = ({
  label, options, value, onChange, columns = 2,
}) => (
  <div className={classes.group}>
    <span className={classes.groupLabel}>{label}</span>

    <div className={classes.cards} style={{ '--cols': columns }}>
      {options.map((option) => {
        const selected = value === option.value;

        return (
          <button
            type="button"
            key={option.value}
            className={clsx(classes.card, selected && classes.selected)}
            onClick={() => onChange(option.value)}
            aria-pressed={selected}
          >
            <span className={classes.body}>
              <span className={classes.title}>{option.title}</span>
              <span className={classes.desc}>{option.desc}</span>
            </span>
            <span className={clsx(classes.radio, selected && classes.radioOn)} />
          </button>
        );
      })}
    </div>
  </div>
);

OptionCardGroup.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  columns: PropTypes.number,
};

export default OptionCardGroup;
